import { Component, Input, OnInit } from '@angular/core';
import { UpdateMode } from 'src/lib/fliko/enums/updateMode';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
  /** @deprecated use headerKey instead */
  @Input() header!: string;
  @Input() headerKey: string | LocLabel | null | undefined;
  /** @deprecated use addTitleKey instead */
  @Input() addTitle!: string;
  @Input() addTitleKey: string | LocLabel | null | undefined;
  /** @deprecated use editTitleKey instead */
  @Input() editTitle!: string;
  @Input() editTitleKey: string | LocLabel | null | undefined;
  @Input() mode!: UpdateMode;
  @Input() exitLink: string = '../';
  /** @deprecated use tooltipKey instead */
  @Input() tooltip?: string;
  @Input() tooltipKey: string | LocLabel | null | undefined;

  UpdateMode = UpdateMode;

  constructor(public rwdService: RWDService) {}

  ngOnInit() {}

  public get addTitleValue(): string | LocLabel | null {
    return this.addTitleKey ?? this.addTitle ?? null;
  }

  public get editTitleValue(): string | LocLabel | null {
    return this.editTitleKey ?? this.editTitle ?? null;
  }

  public get headerValue(): string | LocLabel | null {
    return this.headerKey ?? this.header ?? null;
  }

  public get tooltipValue(): string | LocLabel | null {
    return this.tooltipKey ?? this.tooltip ?? null;
  }
}
